<template>
  <div>
    <el-menu>
      <el-submenu index="1">
        <template slot="title"><span slot="title"><img src="../media/DaveLogo.png" max-width="65%" height="97%"/></span></template>
        <router-link to="/index"><el-menu-item index="1">Homepage</el-menu-item></router-link>
        <router-link to="/deviceList"><el-menu-item index="2">Show current devices</el-menu-item></router-link>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
  export default {
    name: 'SideBar',
    data () {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style  scoped>

  li{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue